import { render, staticRenderFns } from "./VrstaTemeCreate.vue?vue&type=template&id=4e0bf994&scoped=true&"
import script from "./VrstaTemeCreate.vue?vue&type=script&lang=js&"
export * from "./VrstaTemeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0bf994",
  null
  
)

export default component.exports